import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";
import Button from "@components/Button";
import Route from "@assets/svg/DeliveryRoutes/route";
import t from "@constants/localization";

const NoRouteView = ({ onPressAddDeliveryRoute }) => {
  const PATH = "screens/CpDeliveryRoutes/DeliveryRoute";
  return (
    <View style={styles.content}>
      <View style={styles.routeContainer}>
        <View style={styles.routeIcon}>
          <Route width="66" height="66" />
        </View>
      </View>
      <Text style={styles.subtitle} variant="subtitle_16">
        {t(`${PATH}/noRoute`)}
      </Text>
      <Button
        btnText={t(`${PATH}/addDeliveryRoute`)}
        onPress={onPressAddDeliveryRoute}
        buttonWidth="50%"
        buttonColor={color.plain_green}
        borderRadius={8}
        height={45}
        fontSize={14}
      />
    </View>
  );
};

export default NoRouteView;

const styles = StyleSheet.create({
  content: {
    justifyContent: "center",
    alignItems: "center",
    marginTop: "50%",
  },
  routeContainer: {
    backgroundColor: "rgba(237, 28, 36, 0.1)",
    padding: 20,
    borderRadius: 60,
    marginBottom: 20,
  },
  routeIcon: {
    width: 66,
    height: 66,
  },
  subtitle: {
    color: color.mediumBlack,
    textAlign: "center",
    marginBottom: 20,
  },
});
